import React from 'react'
import PropTypes from 'prop-types'

const Logo = props => (
    <svg
        className={props.className}
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="124.695px"
        height="49.085px"
        viewBox="0 0 124.695 49.085"
    >
        <g>
            <g>
                <path
                    fill="#181716"
                    d="M4.33,23.589v9.594H1.319V2.074H4.33v17.285L18.732,2.074h3.633L9.801,17.117l12.35,16.066h-3.759 L7.835,19.403L4.33,23.589z"
                />
                <path
                    fill="#181716"
                    d="M59.896,33.183l-9.376-15.161h3.095c1.935,0,3.53-0.575,4.74-1.709s1.823-2.608,1.823-4.385 c0-1.081-0.188-2.077-0.56-2.96c-0.372-0.882-0.931-1.663-1.658-2.321c-0.601-0.545-1.333-0.938-2.178-1.168c-0.852-0.231-2.393-0.35-4.583-0.35h-4.429v28.054h-3.174V1.912h8.435c1.837,0,3.334,0.141,4.454,0.419c1.124,0.28,2.159,0.747,3.072,1.391c1.244,0.873,2.242,2.055,2.964,3.514c0.721,1.457,1.087,3.022,1.087,4.65c0,2.416-0.729,4.525-2.165,6.27c-1.41,1.712-3.191,2.674-5.298,2.86l7.527,12.168H59.896z"
                />
                <path
                    fill="#181716"
                    d="M78.177,5.129c-2.208,0-3.743,0.117-4.604,0.352c-0.863,0.234-1.598,0.63-2.212,1.186c-0.739,0.67-1.3,1.453-1.677,2.351s-0.566,1.896-0.566,2.991c0,1.81,0.617,3.291,1.848,4.444c1.232,1.154,2.832,1.731,4.797,1.731h2.949l-9.229,14.999h-3.634l7.521-12.157c-2.15-0.156-3.941-1.104-5.373-2.842c-1.432-1.737-2.148-3.811-2.148-6.219c0-1.624,0.361-3.161,1.08-4.614s1.699-2.613,2.938-3.482c0.911-0.642,1.926-1.101,3.045-1.379c1.119-0.277,2.595-0.416,4.434-0.416h8.355v31.109h-3.014V5.129H78.177z"
                />
                <path
                    fill="#181716"
                    d="M99.777,33.265c-4.379,0-8.105-1.559-11.076-4.635c-2.971-3.073-4.476-6.929-4.476-11.458c0-2.121,0.413-4.17,1.229-6.095c0.816-1.924,2.014-3.67,3.561-5.189c1.496-1.467,3.16-2.584,4.949-3.32c1.793-0.739,3.762-1.114,5.853-1.114c2.134,0,4.138,0.378,5.959,1.124c1.817,0.745,3.503,1.872,5.012,3.352c1.546,1.52,2.728,3.244,3.509,5.128s1.176,3.941,1.176,6.115c0,2.158-0.338,4.168-1.008,5.975c-0.668,1.805-1.688,3.47-3.026,4.95c-1.55,1.702-3.324,3.002-5.276,3.865C104.212,32.827,102.062,33.265,99.777,33.265L99.777,33.265z M99.777,4.518c-1.393,0-2.752,0.241-4.041,0.717s-2.493,1.185-3.582,2.107c-1.434,1.214-2.576,2.717-3.396,4.468c-0.821,1.752-1.237,3.569-1.237,5.402c0,3.671,1.21,6.79,3.596,9.27c2.384,2.481,5.368,3.74,8.868,3.74c3.42,0,6.348-1.272,8.702-3.781c2.359-2.51,3.555-5.642,3.555-9.312c0-3.419-1.231-6.407-3.657-8.883C106.157,5.773,103.195,4.518,99.777,4.518L99.777,4.518z"
                />
                <polygon
                    fill="#181716"
                    points="43.377,33.183 32.751,5.15 22.209,33.183 18.808,33.183 30.943,1.912 34.729,1.912 46.82,33.183"
                />
                <path
                    fill="#181716"
                    d="M123.355,33.183h-3.115V4.57h-18.494l-1.859-3.116h23.489V4.57h-0.021V33.183z"
                />
            </g>
            <polygon
                fill="#181716"
                points="21.12,41.909 23.061,47.028 24.986,41.909 25.608,41.909 23.391,47.62 22.699,47.62 20.491,41.909"
            />
            <polygon
                fill="#181716"
                points="23.538,41.909 25.479,47.028 27.403,41.909 28.024,41.909 25.809,47.62 25.117,47.62 22.908,41.909"
            />
            <path
                fill="#181716"
                d="M1.873,45.868v1.765H1.319v-5.724h0.554v3.181l2.65-3.181h0.669L2.88,44.675l2.272,2.957H4.461l-1.942-2.536L1.873,45.868z"
            />
            <path
                fill="#181716"
                d="M10.856,47.632h-0.594l2.222-5.724h0.675l2.214,5.724h-0.602l-0.684-1.797H11.54L10.856,47.632zM13.892,45.321l-1.086-2.874l-1.069,2.874H13.892z"
            />
            <path
                fill="#181716"
                d="M33.845,47.632H33.25l2.223-5.724h0.676l2.214,5.724h-0.602l-0.685-1.797h-2.548L33.845,47.632zM36.88,45.321l-1.086-2.874l-1.069,2.874H36.88z"
            />
            <polygon
                fill="#181716"
                points="82.105,47.079 82.105,41.909 81.551,41.909 81.551,47.079 81.551,47.632 82.105,47.632 84.413,47.632 84.413,47.079"
            />
            <polygon
                fill="#181716"
                points="91.43,42.462 91.43,47.632 91.437,47.632 91.986,47.632 91.99,47.632 91.99,42.462 93.549,42.462 93.549,41.909 91.99,41.909 91.986,41.909 91.437,41.909 91.43,41.909 89.873,41.909 89.873,42.462 	"
            />
            <path
                fill="#181716"
                d="M112.24,47.619l-1.713-2.769h0.566c0.354,0,0.644-0.104,0.865-0.312c0.221-0.207,0.334-0.477,0.334-0.801 c0-0.197-0.035-0.379-0.104-0.541c-0.068-0.16-0.17-0.303-0.302-0.424c-0.11-0.099-0.243-0.171-0.398-0.213c-0.155-0.043-0.437-0.064-0.837-0.064h-0.809v5.123h-0.58v-5.71h1.541c0.334,0,0.608,0.025,0.812,0.077c0.206,0.051,0.395,0.135,0.562,0.253c0.227,0.159,0.408,0.376,0.541,0.643c0.132,0.266,0.197,0.551,0.197,0.849c0,0.441-0.133,0.826-0.395,1.145c-0.258,0.312-0.584,0.488-0.968,0.523l1.374,2.221H112.24z"
            />
            <path
                fill="#181716"
                d="M61.431,45.868v1.765h-0.555v-5.724h0.555v3.181l2.649-3.181h0.67l-2.312,2.767l2.271,2.957h-0.69l-1.942-2.536L61.431,45.868z"
            />
            <path
                fill="#181716"
                d="M118.832,47.632h-0.594l2.223-5.724h0.676l2.213,5.724h-0.602l-0.685-1.797h-2.548L118.832,47.632z M121.867,45.321l-1.085-2.874l-1.068,2.874H121.867z"
            />
            <path
                fill="#181716"
                d="M74.231,41.909v0.546v2.315v2.323h-1.168c-0.729,0-1.289-0.204-1.683-0.613c-0.383-0.398-0.576-0.961-0.585-1.682v-2.89h-0.61v2.966h0.006c0.016,0.46,0.109,0.883,0.293,1.266c0.199,0.415,0.48,0.755,0.845,1.017c0.241,0.17,0.503,0.293,0.782,0.365c0.281,0.073,0.714,0.11,1.298,0.11h1.376v-5.724H74.231z"
            />
            <path
                fill="#181716"
                d="M103.129,41.909v0.546v2.315v2.323h-1.166c-0.73,0-1.291-0.204-1.684-0.613c-0.383-0.398-0.576-0.961-0.586-1.682v-2.89h-0.609v2.966h0.006c0.015,0.46,0.109,0.883,0.293,1.266c0.199,0.415,0.48,0.755,0.845,1.017c0.241,0.17,0.503,0.293,0.782,0.365c0.281,0.073,0.714,0.11,1.297,0.11h1.377v-5.724H103.129z"
            />
            <g>
                <rect
                    x="49.217"
                    y="41.909"
                    fill="#181716"
                    width="0.554"
                    height="1.108"
                />
                <rect
                    x="49.217"
                    y="44.125"
                    fill="#181716"
                    width="0.554"
                    height="3.507"
                />
            </g>
        </g>
    </svg>
)

Logo.propTypes = {
    className: PropTypes.string,
}

Logo.defaultProps = {
    className: '',
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Header/Logo.jsx